import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  campaign: [],
  segment_list: [],
  selected_segments: null
};
export const pMaxSlice = createSlice({
  name: "pMaxSlice",
  initialState: initialState,
  reducers: {
    updateCampaign: (state, action) => {
      state.campaign = action.payload;
    },
    updateSelectedSegments: (state,action) => {
      state.selected_segments = action.payload;
    },
    updateSegmentList: (state, action) => {
      state.segment_list = action.payload;
    },
    resetPMax: () => initialState
  },
});

export const {
  updateCampaign,
  updateSegmentList,
  updateSelectedSegments,
  resetPMax
} = pMaxSlice.actions;
export default pMaxSlice.reducer;
